import React from 'react';
import Image from "next/image";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination"
import blogs1 from "../../public/images/blogs1.jpg";
import blogs2 from "../../public/images/blogs2.jpg";
import blogs3 from "../../public/images/blogs3.jpg";
import blogs4 from "../../public/images/blogs4.jpg";

const Sideblogs = () => {
  return (
    <div className="columns books">
        <span className="title"><h2 className='text-[#ffff] text-3xl'>Blogs</h2></span>
          <div className="">
          <Swiper
        spaceBetween={50}
        centeredSlides={true}
        initialSlide={1}
        speed={1000}
        loop={true}
        roundLengths={true}
        mousewheel={true}
        grabCursor={true}
        slidesPerView={1}
        autoplay={{
          delay: 2000,
          disableOnInteraction: false,
        }}
        modules={[Autoplay, Pagination, Navigation]}
        className="mySwiper"
      >
        <SwiperSlide>
            <div className=''> <Image src={blogs1} alt='virtual campus drive meaning' className='w-full h-full'/></div>
        </SwiperSlide>
        <SwiperSlide>
            <div className=''> <Image src={blogs2} alt='virtual campus recruitment platform' className='w-full h-full'/></div>
         </SwiperSlide>       
         <SwiperSlide>
            <div className=''> <Image src={blogs3} alt='resume' className='w-full h-full'/></div>
          </SwiperSlide>       
         <SwiperSlide>
            <div className=''> <Image src={blogs4} alt='resume format' className='w-full h-full'/></div>
          </SwiperSlide>   
          </Swiper>
          </div>
      </div>
  )
}

export default Sideblogs